import { isApiError, isAuthenticationRequired, isNetworkError } from '@liniya/api-client';
import { QueryClient } from '@tanstack/react-query';

/**
 * Cache and retry policy for server state.
 *
 * The socket is what keeps data fresh, so polling is off and refetching on
 * window focus is limited to the moments where the socket may have missed
 * something. Retries are for transport failures only: repeating a request the
 * server has already refused wastes the user's connection and, on a
 * rate-limited endpoint, digs the hole deeper.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 10 * 60_000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        retry: (failureCount, error) => {
          if (isAuthenticationRequired(error)) return false;
          if (isApiError(error)) return false;
          if (isNetworkError(error)) return failureCount < 2;
          return false;
        },
        retryDelay: (attempt) => Math.min(4000, 400 * 2 ** attempt),
      },
      mutations: {
        retry: false,
      },
    },
  });
}
